/**
 * Mapping of category keys to API constants
 */
const CATEGORY_KEY_MAP: Record<string, string> = {
	zbrojniOpravneni: 'ZBROJNI_OPRAVNENI_B',
	zbrojniLicence: 'ZBROJNI_LICENCE_ZL3_C',
	evropskyZbrojniPas: 'EVROPSKY_ZBROJNI_PAS_D',
	municniOpravneniNakladaniMunice: 'MUNICNI_OPRAVNENI_E',
	aprobace: 'APROBACE_F',
	zapsanaAutorizace: 'ZAPSANA_AUTORIZACE_G',
	vyjimkyNaZbranKategorieR1: 'VYJIMKA_R1_H',
	vyjimkyNaStrelivoS1: 'VYJIMKA_S1_H_B',
	vyjimkyNaZbranStrelivoKategorieR2S2: 'VYJIMKA_R2S2_I',
	vyjimkyNaNadlimitniZasobnik: 'VYJIMKA_NADLIMITNI_ZASOBNIK_J',
	povoleniNaZbranKategorieR3: 'POVOLENI_K_NABYTI_R3_K',
	zbraneHlavnihoDrziteleR1R2R3R4: 'PRUKAZ_ZBRANE_L',
	vedlejsiZbrane: 'ZBRANE_KDE_JE_VEDLEJSIM_DRZITELEM_M',
	ohlaseneZbraneKategoriePO: 'OHLASENE_ZBRANE_N',
};

/**
 * Transforms selected categories into the format expected by the API
 *
 * Input format: ["categoryKey", "categoryKey:*", "categoryKey:itemId"]
 * Output format: ["API_CATEGORY_KEY", "API_CATEGORY_KEY:*", "API_CATEGORY_KEY:itemId"]
 *
 * @param selectedCategories - Array of selected category keys
 * @returns Array of keys with API category names
 */
export const mapSelectedCategories = (selectedCategories: string[]): string[] =>
	selectedCategories.map((selection) => {
		// Split into categoryKey and optional suffix (itemId or *)
		const [categoryKey, suffix] = selection.split(':');

		// Find the API key
		const apiKey = CATEGORY_KEY_MAP[categoryKey];

		if (!apiKey) {
			console.warn(`Unknown category key: ${categoryKey}`);
			return selection; // Return original value if not found in map
		}

		// If suffix exists, append it after colon
		return suffix ? `${apiKey}:${suffix}` : apiKey;
	});
